<template>
    <div
        key="small-boxes flex"
        class="small-box-container"
    >
        <subscription-box />
        <card-box />
    </div>
</template>

<script>
import SubscriptionBox from '@/components/Dashboard/Settings/Billing/SubscriptionBox';
import CardBox from '@/components/Dashboard/Settings/Billing/CardBox';

export default {
    components: {
        SubscriptionBox,
        CardBox,
    },
};
</script>
